/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import React from 'react';

import useStyles from './styles';

const DisplayInformation = ({
  values,
  staticGroupLabel = false,
  staticGroupLabelText = '',
  dynamicGroupLabel = false,
  singleGroupValue = false,
  singleGroupLabelText = '',
  singleGroupValueText = '',
}) => {
  const styles = useStyles();
  return (
    <>
      {dynamicGroupLabel &&
        values &&
        values.length > 0 &&
        values.map((selectedValue, outerIndex) => {
          if (selectedValue?.rows && selectedValue?.rows.length > 0) {
            return (
              <React.Fragment key={outerIndex}>
                <div css={styles.group}>
                  <div css={styles.groupLabel}>
                    {selectedValue?.title &&
                    selectedValue?.title === 'Disability Facilities'
                      ? 'Disabled Facilities'
                      : selectedValue?.title}
                  </div>
                  <div css={styles.groupValue}>
                    {selectedValue?.rows &&
                    selectedValue?.rows.length > 0 &&
                    Array.isArray(selectedValue?.rows)
                      ? selectedValue?.rows.map(
                          (facility, index) =>
                            `${facility} ${
                              index === selectedValue?.rows.length - 1
                                ? ''
                                : ' - '
                            }`
                        )
                      : ''}
                  </div>
                </div>
              </React.Fragment>
            );
          }
          return null;
        })}

      {staticGroupLabel && (
        <div css={styles.group}>
          <div css={styles.groupLabel}>{staticGroupLabelText}</div>
          <div css={styles.groupValue}>
            {values &&
              values.length > 0 &&
              values.map((selectedValue, outerIndex) => {
                const filteredRows = selectedValue?.rows?.filter(
                  facility => facility !== undefined
                );
                if (filteredRows && filteredRows.length > 0) {
                  return (
                    <React.Fragment key={outerIndex}>
                      {filteredRows.map((facility, innerIndex) => (
                        <span key={innerIndex}>
                          {facility}
                          {!(
                            outerIndex === values.length - 1 &&
                            innerIndex === filteredRows.length - 1
                          ) && ' - '}
                        </span>
                      ))}
                    </React.Fragment>
                  );
                }
                return null;
              })}
          </div>
        </div>
      )}
      {singleGroupValue && (
        <div css={styles.group}>
          <div css={styles.groupLabel}>{singleGroupLabelText}</div>
          <div css={styles.groupValue}>{singleGroupValueText}</div>
        </div>
      )}
    </>
  );
};

DisplayInformation.propTypes = {
  values: PropTypes.array,
  staticGroupLabel: PropTypes.bool,
  staticGroupLabelText: PropTypes.string,
  dynamicGroupLabel: PropTypes.bool,
  singleGroupValue: PropTypes.bool,
  singleGroupLabelText: PropTypes.string,
  singleGroupValueText: PropTypes.string,
};

export default DisplayInformation;
